(function (angular, schoolwork12) {

    'use strict';
    var fulfillmentapp = angular.module(schoolwork12.app.fulfillment.name);

    fulfillmentapp.controller(schoolwork12.app.fulfillment.controllers.fulfillment, [
        '$rootScope', '$scope',
        '$http', '$timeout', schoolwork12.app.auth.services.authentication,
        schoolwork12.app.common.services.eventNotification,
        'getSchools', '$uibModal',
        function ($rootScope, $scope, $http, $timeout,
            authentication, eventNotification, schoolservice, $uibModal) {
            console.info("In fulfillment controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Fulfillment controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
                    $scope.isRuleManager = authentication.hasComputerRuleManagerRole();
                });
            $scope.isAddNewClicked = false;
            $scope.errorOccured = false;
            $scope.showEditModalSuccessMessage = false;
            $scope.showCreateModalSuccessMessage = false;
            $scope.schoolData = [];
            if(authentication.getCurrentUser()){
                $scope.isRuleManager = authentication.hasComputerRuleManagerRole();
            } 
            var rowtpl='<div ng-class="grid.options.rowStyle(row)"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"                         class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell></div></div>';
            $scope.gridOptions = {
                enableFiltering: true,
                enableColumnResizing: true,
                paginationPageSizes: [25, 50, 75],
                paginationPageSize: 25,
                //showGridFooter : true,
                rowHeight: 50,
                enableRowSelection: true,
                enableRowHeaderSelection: true,
                rowStyle: function(row){                    
                   if(row.entity.editCompleted){
                        return 'fulfillmentRowsEdited';
				    }
                   if(row.entity.recalculateSucess){
                       return 'fulfillmentRowsEdited';
				    }
                    if($scope.showCreateModalSuccessMessage){
                        if($scope.gridOptions.data.indexOf(row.entity) == 0){
                           return 'fulfillmentRowsEdited';
                        }
                    }
                },
                rowTemplate:rowtpl,
                onRegisterApi: function (gridApi) {
                    $scope.gridApi = gridApi;
                    $scope.resizeGrid = {
                        'width': '100%'
                    };
                },
            };
            $scope.gridOptions.columnDefs = [
                {
                    field: 'name',
                    headerCellClass: $scope.highlightFilteredHeader,
                    displayName: 'School Name',
                    cellTemplate: '<div class="ui-grid-cell-contents configureEdit" ng-click="grid.appScope.updateModal(grid, row, size)">                                                                {{row.entity[col.field]}}</div>',
                },
                {
                    field: 'ruleStartDate',
                    enableFiltering: false,
                    enableSorting: false,
                    displayName: 'Rule Start Date',
                },
                {
                    field: 'ruleEnddate',
                    enableFiltering: false,
                    enableSorting: false,
                    displayName: 'Rule End Date'
                }
            ];
            var allSchoolListAuthPromise = null;
            $scope.isSpinnerActive = true;
            if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                console.info('Keycode found.Making a call to service');
                allSchoolListAuthPromise = schoolservice.getConfiguredSchoolList(authentication.getCurrentUser().keycode);
                allSchoolListAuthPromise.then(function (data) {                    
                    $scope.schoolData = data;
                    //console.info(angular.toJson($scope.schoolData));
                    $scope.gridOptions.data = $scope.schoolData;
                }, function (error) {
                    console.error('Error when calling get configured schools sevice....'.concat(angular.toJson(error)));
                    $scope.errorOccured = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.ErrorMesg = $scope.ErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.ErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.ErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }

                })['finally'](function () {
                    $scope.isSpinnerActive = false;
                });
            } else {
                console.info('Key code not found. Using time out function to make a call');
                $timeout(function () {
                    allSchoolListAuthPromise = schoolservice.getConfiguredSchoolList(authentication.getCurrentUser().keycode);
                    allSchoolListAuthPromise.then(function (data) {
                        $scope.schoolData = data;
                        //console.info(angular.toJson($scope.schoolData));
                        $scope.gridOptions.data = $scope.schoolData;
                    }, function (error) {
                        console.error('Error when calling get configured schools sevice....'.concat(angular.toJson(error)));
                        $scope.errorOccured = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.ErrorMesg = $scope.ErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.ErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.ErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })['finally'](function () {
                        $scope.isSpinnerActive = false;
                    });
                }, 500);
            };            
            $scope.createNewModel = function () {
                $scope.showEditModalSuccessMessage = false;
                $scope.showCreateModalSuccessMessage = false;
                var createModalInstance = $uibModal.open({
                    templateUrl: schoolwork12.app.fulfillment.templates.openCreateModal,
                    size: 'lg',
                    scope: $scope,
                    controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.isCreateModalSpinnerActive = true;                        
                        var schoolTypeArray = [];
                        var schoolNameArray = [];
                        var allSchoolDetails = {};
                        var schoolDisplayArray = [];
                        var defaultOptions = {
                            value: "ALL"
                        };
                        var collections = [];
                        $scope.schoolNotSelected = false;
                        $scope.schoolNameAndIdArray = [];
                        $scope.selectedSchool = {
                            "schoolId": "default",
                            "ruleStartDate": "",
                            "ruleEnddate": "",
                            "oneFamilyHWVaries" : false,
                            "farmFromFIF" : false
                        };
                        $scope.showAddSign = true;
                        $scope.showRemoveSign = true;
                        $scope.updateSuccess = false;
                        $scope.ErrorMesg = '';
                        $scope.ruleStartDatePicker = {
                            opened: false
                        };
                        $scope.ruleEndDatePicker = {
                            opened: false
                        };
                        $scope.ruleEndDateOpen = function () {
                            $scope.ruleEndDatePicker.opened = true;
                        };
                        $scope.ruleStartDateOpen = function () {
                            $scope.ruleStartDatePicker.opened = true;
                        };

                        $scope.selectedSchoolType = defaultOptions;
                        const schoolListAuthpromise = schoolservice.getAllSchoolsList(authentication.getCurrentUser().keycode);
                        const getBundleDetails = schoolservice.getBundleTypes(authentication.getCurrentUser().keycode);

                        const handleSchoolList = (data)=>{
                            if (data) {
                                allSchoolDetails = data;
                                $scope.allSchoolDetails = allSchoolDetails;
                                for (var i = 0, keys = Object.keys(data), ii = keys.length; i < ii; i++) {
                                    schoolTypeArray.push(keys[i]);
                                    for (var j = 0, values = data[keys[i]], jj = data[keys[i]].length; j < jj; j++) {
                                        schoolNameArray.push(values[j].name);
                                        $scope.schoolNameAndIdArray.push({
                                            'schoolName': values[j].name,
                                            'id': values[j].schoolId
                                        })
                                    }
                                }
                                $scope.schoolTypeArray = schoolTypeArray;
                                $scope.schoolTypeArray.sort();
                                $scope.schoolDisplayArray = $scope.schoolNameAndIdArray;
                            }
                        }

                        const handleBundleDetails = (data) =>  {
                            $scope.bundleTypes = data
                        };

                        Promise.all([schoolListAuthpromise, getBundleDetails]).then(([schoolResponse, bundleResponse])=>{
                            handleBundleDetails(bundleResponse);
                            handleSchoolList(schoolResponse);
                        }).catch(error=>{
                            $scope.errorOccuredInCreateModal = true;
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.ErrorMesgInCreateModal = $scope.ErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.ErrorMesgInCreateModal = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.ErrorMesgInCreateModal = schoolwork12.app.errorMessages.internalError;
                            }
                        }).finally(()=>{
                            $scope.isCreateModalSpinnerActive = false;
                        });

                        $scope.changeSchoolValues = function () {
                            $scope.selectedSchool.schoolId = "default";
                            if ($scope.selectedSchoolType.value == "ALL") {
                                $scope.schoolDisplayArray = $scope.schoolNameAndIdArray;
                            } else {
                                var newDisplayArray = [];
                                var arrayForSchoolType = $scope.allSchoolDetails[$scope.selectedSchoolType.value];
                                for (var j = 0; j < arrayForSchoolType.length; j++) {
                                    newDisplayArray.push({
                                        'schoolName': arrayForSchoolType[j].name,
                                        'id': arrayForSchoolType[j].schoolId
                                    });
                                }
                                $scope.schoolDisplayArray = newDisplayArray;
                            };
                        };

                        var intialCollection = {
                            "startGradeCode": "",
                            "endGradeCode": "",
                            "farmEligible": false,
                            "manualApprovalRequired": false,
                            "bundleType": "",
                            "ratio": ""
                        };
                        collections.push(intialCollection);
                        $scope.collections = collections;
                        
                        $scope.addRow = function () {
                            var addToCollection = {
                                "startGradeCode": "",
                                "endGradeCode": "",
                                "farmEligible": false,
                                "manualApprovalRequired": false,
                                "bundleType": "",
                                "ratio": ""
                            };
                            $scope.collections.push(addToCollection);
                        };
                        $scope.deleteRow = function (index) {
                            $scope.collections.splice(index, 1);
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                        $scope.ruleStartDateNotSelected = false;
                        $scope.validateAndSave = function () {                           
                            var validGrades = validateGradeRanges($scope.collections);
                            if (!validGrades) {
                                $scope.gradeRangeNotValid = true;
                            } else {
                                $scope.showAddSign = false;
                                $scope.showRemoveSign = false;
                                $scope.disableSubmit = true;
                                $scope.gradeRangeNotValid = false;
                                var schoolRules = {};
                                var ruleStartDate = $scope.selectedSchool.ruleStartDate;
                                var ruleStartDateToSend;
                                if (typeof ruleStartDate == 'string') {
                                    ruleStartDateToSend = ruleStartDate;
                                } else {
                                    ruleStartDateToSend = $scope.getMonthInFormat(ruleStartDate) + '-' + $scope.getDayInFormat(ruleStartDate) + '-' +
                                        ruleStartDate.getUTCFullYear();
                                }
                                $scope.selectedSchool.ruleStartDate = ruleStartDateToSend;
                                var ruleEndDate = $scope.selectedSchool.ruleEnddate;
                                //console.info(ruleEndDate);
                                var ruleEndDateToSend = '';
                                if (ruleEndDate != '' && ruleEndDate != null) {
                                    if (typeof ruleEndDate == 'string') {
                                        ruleEndDateToSend = ruleEndDate;
                                    } else {
                                        ruleEndDateToSend = $scope.getMonthInFormat(ruleEndDate) + '-' + $scope.getDayInFormat(ruleEndDate) + '-' + ruleEndDate.getUTCFullYear();
                                    }
                                }
                                schoolRules.ruleStartDate = ruleStartDateToSend;
                                schoolRules.schoolId = $scope.selectedSchool.schoolId;
                                if (ruleEndDateToSend != '') {
                                    schoolRules.ruleEnddate = ruleEndDateToSend
                                    $scope.selectedSchool.ruleEnddate = ruleEndDateToSend;
                                };
                                var schoolDetails = [];
                                for (var j = 0; j <= $scope.collections.length - 1; j++) {
                                    var dummyObject = {};
                                    dummyObject.startGradeCode = $scope.collections[j].startGradeCode;
                                    dummyObject.endGradeCode = $scope.collections[j].endGradeCode;                                    
                                    dummyObject.farmEligible = $scope.collections[j].farmEligible;
                                    dummyObject.manualApprovalRequired = $scope.collections[j].manualApprovalRequired;
                                    dummyObject.oneFamilyHWVaries = $scope.selectedSchool.oneFamilyHWVaries;
                                    dummyObject.farmFromFIF = $scope.selectedSchool.farmFromFIF;
                                    dummyObject.bundleType = $scope.collections[j].bundleType;
                                    dummyObject.ratio = $scope.collections[j].ratio;
                                    schoolDetails.push(dummyObject);
                                };
                                var putData = {
                                    "schoolRules":schoolRules,
                                    "schoolDetails":schoolDetails
                                };                                
                                //console.info(angular.toJson(putData));
                                $scope.putData = putData;
                                console.info("Calling update service");
                                var updateAuthPromise = schoolservice.updateFulfillmentDetails(authentication.getCurrentUser().keycode,
                                                                                              $scope.selectedSchool.schoolId,putData);
                                updateAuthPromise.then(function (data) {
                                    $scope.updateSuccess = true;
                                    $scope.errorOccuredInCreateModal = false;
                                    $scope.sucessMessage = data;                                    
                                    console.info("Sucessfully updated school response");
                                    for(var i =0; i< $scope.schoolDisplayArray.length -1 ; i++){
                                        if($scope.schoolDisplayArray[i].id == $scope.putData.schoolRules.schoolId){
                                            $scope.putData.schoolName = $scope.schoolDisplayArray[i].schoolName;
                                            break;
                                        }
                                    }
                                    $uibModalInstance.close($scope.putData);
                                }, function (error) {
                                    $scope.ErrorMesg='';
                                    $scope.showAddSign = true;
                                    $scope.showRemoveSign = true;
                                    $scope.disableSubmit = false;
                                    //console.error('Error when calling update fulfillment rules for school sevice....'.concat(angular.toJson(error)));
                                    $scope.errorOccuredInCreateModal = true;
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            console.info(error.data._errors[j]);
                                            $scope.ErrorMesgInCreateModal = $scope.ErrorMesg + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.ErrorMesgInCreateModal = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.ErrorMesgInCreateModal = schoolwork12.app.errorMessages.internalError;
                                    }

                                })['finally'](function () {
                                    //$scope.isModalSpinnerActive = false;
                                });                                
                            };
                        };
                        $scope.getMonthInFormat = function (date) {
                            var month = date.getUTCMonth() + 1;
                            return month < 10 ? '0' + month : month;
                        };
                        $scope.getDayInFormat = function (date) {
                            var day = date.getUTCDate();
                            return day < 10 ? '0' + day : day;
                        };
                        var validateGradeRanges = function (collections) {
                            var gradeSorted = true;
                            var gradeOrder = ['UNDEFINED', 'TK', 'K', '1', '2', '3', '4', '5', '6', '7',
						    		 '8', '9', '10', '11', '12', 'OTHER', 'AL'];
                            for (var i = 0; i <= collections.length - 1; i++) {
                                if (gradeOrder.indexOf(collections[i].startGradeCode) > gradeOrder.indexOf(collections[i].endGradeCode)) {
                                    gradeSorted = false;
                                    break;
                                };
                            };
                            return gradeSorted;
                        };
                    }],
                });
                
                createModalInstance.result.then(function (data) {                    
                    //console.info(angular.toJson(data));
                    var newDataAdded = {};
                    newDataAdded.enrollDateString = '01-01-4712';
                    newDataAdded.ruleStartDate = data.schoolRules.ruleStartDate;
                    newDataAdded.ruleEnddate=data.schoolRules.ruleEnddate;
                    newDataAdded.schoolId = data.schoolRules.schoolId;
                    newDataAdded.name = data.schoolName;                   
                    $scope.schoolData.unshift(newDataAdded);
                    $scope.showCreateModalSuccessMessage = true;                    
                    $scope.CreateMesg = schoolwork12.app.fulfillmentApproval.editMessages.editSuccess;
				});
            };
            
            
            
            
            $scope.updateModal = function (grid, row, size) {
                $scope.showEditModalSuccessMessage = false;
                $scope.showCreateModalSuccessMessage = false;
                var modalInstance = $uibModal.open({
                    templateUrl: schoolwork12.app.fulfillment.templates.openEditModal,
                    size: 'lg',
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance', 'grid', 'row', 'authentication', function ($scope, $uibModalInstance, grid, row, authentiction) {
                        $scope.selectedSchool = angular.copy(row.entity);                        
                        $scope.isModalSpinnerActive = true;
                        $scope.gradeRangeNotValid = false;
                        $scope.errorOccuredInModal = false;
                        $scope.errorOccuredInRecalculateModal = false;
                        $scope.isRecalulateBusy = false;
                        $scope.showAddSign = true;
                        $scope.showRemoveSign = true;
                        $scope.disableSubmit = false;
                        $scope.updateSuccess = false;
                        $scope.isRuleManager = true;
                        $scope.ErrorMesg = '';
                        $scope.ruleStartDatePicker = {
                            opened: false
                        };
                        $scope.ruleEndDatePicker = {
                            opened: false
                        };
                        $scope.ruleEndDateOpen = function () {
                            $scope.ruleEndDatePicker.opened = true;
                        };
                        $scope.ruleStartDateOpen = function () {
                            $scope.ruleStartDatePicker.opened = true;
                        };
                        $scope.forms = {};
                        var getBundleDetails = schoolservice.getBundleTypes(authentiction.getCurrentUser().keycode);
                        getBundleDetails.then(function (data) {
                            $scope.bundleTypes = data;
                            console.info("Sucessfully got response for bundle Types");
                        }, function (error) {
                            console.error('Error when getting the bundle types....'.concat(angular.toJson(error)));
                            $scope.errorOccuredInModal = true;
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.ErrorMesgInModal = $scope.ErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.internalError;
                            }

                        })['finally'](function () {
                            // $scope.isModalSpinnerActive = false;
                        });
                        var schoolDetailsAuthPromise = schoolservice.getConfiguredSchoolDetails(authentication.getCurrentUser().keycode,
                            $scope.selectedSchool.ruleStartDate,
                            $scope.selectedSchool.ruleEndDate,
                            $scope.selectedSchool.schoolId);
                        schoolDetailsAuthPromise.then(function (data) {
                            $scope.collections = data;
                            if(data.length > 0) {
								//setting the checkbox with its corresponding value
                                $scope.selectedSchool.oneFamilyHWVaries = $scope.collections[0].oneFamilyHWVaries;
                                $scope.selectedSchool.farmFromFIF = $scope.collections[0].farmFromFIF;
                            }
                            console.info("Sucessfully got response");
                        }, function (error) {
                            console.error('Error when calling get configured schools sevice....'.concat(angular.toJson(error)));
                            $scope.errorOccuredInModal = true;
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.ErrorMesgInModal = $scope.ErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.internalError;
                            }

                        })['finally'](function () {
                            $scope.isModalSpinnerActive = false;
                        });
                        //check if user is admin user or rule manager.
                        $scope.isRuleManager = authentiction.hasComputerRuleManagerRole();
                        if (!$scope.isRuleManager) {
                            var ratioObject = {
                            	"0": "One computer per family",
                                "1": 'One computer per student',
                                "2": "One computer per two students in family",
                                "3": "One computer per three students in family"                                
                            };
                            $scope.ratioObject = ratioObject;
                            /* $timeout(function () {
                                 for (var i = 0; i <= $scope.collections.length - 1; i++) {
                                     $scope.collections[i].ratio = ratioObject[$scope.collections[i].ratio];
                                 };
                             }, 500);
                             */
                        };
                        $scope.getRatioDescription = function (type) {
                            var description = $scope.ratioObject[type];
                            return description;
                        };

                        $scope.getBundleDescription = function (type) {
                            var description;
                            for (var j = 0; j < $scope.bundleTypes.length - 1; j++) {
                                if ($scope.bundleTypes[j].bundleCode == type) {
                                    description = $scope.bundleTypes[j].bundleDescription;
                                    break;
                                }
                            }
                            return description;
                        };
                        $scope.addRow = function () {
                            var intialCollection = {
                                "startGradeCode": "",
                                "endGradeCode": "",
                                "farmEligible": false,
                                "manualApprovalRequired": false,
                                "bundleType": "",
                                "ratio": "",
                                "computerRuleId": ""
                            };
                            $scope.collections.push(intialCollection);
                        };
                        $scope.deleteRow = function (index) {
                            $scope.collections.splice(index, 1);
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                        $scope.validateAndSave = function () {
                            console.info("Validating fields grade ranges");
                            var validGrades = validateGradeRanges($scope.collections);
                            if (!validGrades) {
                                $scope.gradeRangeNotValid = true;
                            } else {
                                $scope.showAddSign = false;
                                $scope.showRemoveSign = false;
                                $scope.disableSubmit = true;
                                $scope.gradeRangeNotValid = false;
                                row.entity.editCompleted = false;
                                var schoolRules = {};
                                var ruleStartDate = $scope.selectedSchool.ruleStartDate;
                                var ruleStartDateToSend;
                                if (typeof ruleStartDate == 'string') {
                                    ruleStartDateToSend = ruleStartDate;
                                } else {
                                    ruleStartDateToSend = $scope.getMonthInFormat(ruleStartDate) + '-' + $scope.getDayInFormat(ruleStartDate) + '-' +
                                        ruleStartDate.getUTCFullYear();
                                }
                                $scope.selectedSchool.ruleStartDate = ruleStartDateToSend;
                                var ruleEndDate = $scope.selectedSchool.ruleEnddate;
                                //console.info(ruleEndDate);
                                var ruleEndDateToSend = '';
                                if (ruleEndDate != '' && ruleEndDate != null) {
                                    if (typeof ruleEndDate == 'string') {
                                        ruleEndDateToSend = ruleEndDate;
                                    } else {
                                        ruleEndDateToSend = $scope.getMonthInFormat(ruleEndDate) + '-' + $scope.getDayInFormat(ruleEndDate) + '-' + ruleEndDate.getUTCFullYear();
                                    }
                                }
                                schoolRules.ruleStartDate = ruleStartDateToSend;
                                schoolRules.schoolId = $scope.selectedSchool.schoolId;
                                if (ruleEndDateToSend != '') {
                                    schoolRules.ruleEnddate = ruleEndDateToSend;
                                    $scope.selectedSchool.ruleEnddate = ruleEndDateToSend;
                                }
                                var schoolDetails = [];
                                for (var j = 0; j <= $scope.collections.length - 1; j++) {
                                    var dummyObject = {};
                                    dummyObject.startGradeCode = $scope.collections[j].startGradeCode;
                                    dummyObject.endGradeCode = $scope.collections[j].endGradeCode;
                                    if ($scope.collections[j].computerRuleId != '') {
                                        dummyObject.computerRuleId = $scope.collections[j].computerRuleId;
                                    }
                                    dummyObject.farmEligible = $scope.collections[j].farmEligible;
                                    dummyObject.manualApprovalRequired = $scope.collections[j].manualApprovalRequired;
                                    dummyObject.bundleType = $scope.collections[j].bundleType;
                                    dummyObject.oneFamilyHWVaries = $scope.selectedSchool.oneFamilyHWVaries;
                                    dummyObject.farmFromFIF = $scope.selectedSchool.farmFromFIF;
                                    dummyObject.ratio = $scope.collections[j].ratio;
                                    schoolDetails.push(dummyObject);
                                };
                                var putData = {
                                    "schoolRules": schoolRules,
                                    "schoolDetails": schoolDetails
                                };
                                //console.info(angular.toJson(putData));
                                $scope.putData = putData;
                                console.info("Calling update service");
                                var updateAuthPromise = schoolservice.updateFulfillmentDetails(authentication.getCurrentUser().keycode,
                                    $scope.selectedSchool.schoolId, putData);
                                updateAuthPromise.then(function (data) {
                                    $scope.updateSuccess = true;
                                    $scope.errorOccuredInModal = false;
                                    $scope.sucessMessage = data;
                                    console.info("Sucessfully updated school response");                                    
                                    row.entity.ruleStartDate = $scope.selectedSchool.ruleStartDate;
                                    row.entity.ruleEnddate = $scope.selectedSchool.ruleEnddate;
                                    //console.info(angular.toJson(row.entity));
                                    row.entity.editCompleted = true;
                                    $uibModalInstance.close(row.entity);
                                }, function (error) {                                    
                                    $scope.showAddSign = true;
                                    $scope.showRemoveSign = true;
                                    $scope.disableSubmit = false;
                                    //console.error('Error when calling update fulfillment rules for school sevice....'.concat(angular.toJson(error)));
                                    $scope.errorOccuredInModal = true;
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            console.info(error.data._errors[j]);
                                            $scope.ErrorMesgInModal = $scope.ErrorMesg + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.internalError;
                                    }

                                })['finally'](function () {
                                    //$scope.isModalSpinnerActive = false;
                                });
                            };
                        };
                        $scope.reCalculate = function(){                      
                            $scope.errorOccuredInModal = false;
                            $scope.errorOccuredInRecalculateModal = false;
                            $scope.ErrorMesgInModal = '';
                            $scope.isRecalulateBusy = true;
                            row.entity.editCompleted = false;
                            row.entity.recalculateSucess = false;
                            var putData = {"reason": "rules updated by " + authentication.getCurrentUser().username};
                            //console.info(angular.toJson(putData));
                            $scope.putData = putData;
                            console.info("Calling recalculate service" + putData);
                            var recalculateAuthPromise = schoolservice.recalculateSchool(authentication.getCurrentUser().keycode,
                                    								 $scope.selectedSchool.schoolId, putData);
                                recalculateAuthPromise.then(
                            	  function (data) {
                                    $scope.updateSuccess = true;
                                    $scope.sucessMessage = data;
                                    console.info("Sucessfully updated school response");                                    
                                   // row.entity.editCompleted = true;
                                    row.entity.recalculateSucess = true;
                                    $uibModalInstance.close(row.entity);
                            	 },
                            	 function (error) {                                    
                                        $scope.errorOccuredInRecalculateModal = true;
                                        if (error.status == 400) {
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                console.info(error.data._errors[j]);
                                                $scope.ErrorMesgInModal = $scope.ErrorMesg + error.data._errors[j] + "\n";
                                            }
                                        } else if (error.status == 401 || error.status == 403) {
                                            $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.internalError;
                                        }

                                    }
                            	 )['finally'](function () {
                            		 $scope.isRecalulateBusy = false;
                            		 });                     
                        }; 
                        
                        $scope.getMonthInFormat = function (date) {
                            var month = date.getUTCMonth() + 1;
                            return month < 10 ? '0' + month : month;
                        };
                        $scope.getDayInFormat = function (date) {
                            var day = date.getUTCDate();
                            return day < 10 ? '0' + day : day;
                        };
                        $scope.showRecalculateButton = function () {
                           	var ruleStartDate = angular.copy($scope.selectedSchool.ruleStartDate);    
                            var ruleEndDate =  angular.copy($scope.selectedSchool.ruleEnddate);
                            var showButton = false;
                            if ((moment(ruleStartDate,'MM-DD-YYYY') < moment()) && 
                            		(typeof(ruleEndDate) == 'undefined' || ruleEndDate == null || ruleEndDate == '' || (moment(ruleEndDate,'MM-DD-YYYY') > moment()))
                            	){
                            	showButton = true;
    	                    }
                            return showButton;
                        };
                        var validateGradeRanges = function (collections) {
                            var gradeSorted = true;
                            var gradeOrder = ['UNDEFINED', 'TK', 'K', '1', '2', '3', '4', '5', '6', '7',
						    		 '8', '9', '10', '11', '12', 'OTHER', 'AL'];
                            for (var i = 0; i <= collections.length - 1; i++) {
                                if (gradeOrder.indexOf(collections[i].startGradeCode) > gradeOrder.indexOf(collections[i].endGradeCode)) {
                                    gradeSorted = false;
                                    break;
                                };
                            };
                            return gradeSorted;
                        };
                     }],
                    resolve: {
                        grid: function () {
                            return grid;
                        },
                        row: function () {
                            return row;
                        }
                    }
                });
                
                modalInstance.result.then(function () {
				    $scope.showEditModalSuccessMessage = false;
				    if(row.entity.editCompleted){
		  				$scope.showEditModalSuccessMessage = true;
		  				$scope.EditMesg = schoolwork12.app.fulfillmentApproval.editMessages.editSuccess;
	  	            }
				    if(row.entity.recalculateSucess){
				    	$scope.showEditModalSuccessMessage = true;
				    	$scope.EditMesg = schoolwork12.app.fulfillmentApproval.editMessages.recalculateSuccess;
				    }
				});
            };
        }]);

}(angular, schoolwork12));
